// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__-XylH","addWidgetButton":"Header_addWidgetButton__heIz8","dashboardTabs":"Header_dashboardTabs__2Nz8n","active":"Header_active__2mJfj"};